module.exports = __webpack_public_path__ + "media/landing_page/success-check-bce49195.svg";